import dynamic from 'next/dynamic';

const DynamicCssBaseline = dynamic(() => import('@mui/material/CssBaseline'), {
    ssr: true,
});

export default DynamicCssBaseline;
